"use client"

import { GameCard } from "@/components/GameCard"
import { GameItem } from "@/app/types"
import * as Icons from "@/assets/icons/gameicon"

const activities: GameItem[] = [
  {
    id: "1",
    title: "Find the match",
    description: "Tap the matching answer to eliminate it. Repeat until all answers are gone.",
    icon: <Icons.FindTheMatch />,
  },
  {
    id: "2",
    title: "Game show Quiz",
    description: "A series of multiple choice questions. Tap the correct answer to proceed.",
    icon: <Icons.GameShowQuiz />,
    kind: "quiz",
    href: "/create-game/quiz",
  },
  {
    id: "3",
    title: "Flip cards",
    description: "Test yourself using cards with prompts on the front and answers on the back.",
    icon: <Icons.FlipCards />,
  },
  {
    id: "4",
    title: "Air plan / Flying Fruits",
    description: "Drag and drop each item into its correct group.",
    icon: <Icons.AirPlan />,
  },
  {
    id: "5",
    title: "Flappy Bird",
    description: "Drag and drop each keyword next to its definition.",
    icon: <Icons.MatchUp />,
  },
  {
    id: "6",
    title: "ตีตุ่น",
    description: "Drag and drop words to rearrange each sentence into its correct order.",
    icon: <Icons.SentenceOrder />,
  },
  {
    id: "7",
    title: "Anagram",
    description: "Drag the letters into their correct positions to unscramble the word or phrase.",
    icon: <Icons.Anagram />,
  },
  {
    id: "8",
    title: "Complete the sentence",
    description: "A cloze activity where you drag and drop words into blank spaces within a text.",
    icon: <Icons.CompleteSentence />,
  },
  {
    id: "9",
    title: "Situation",
    description: "Test yourself using cards with prompts on the front and answers on the back.",
    icon: <Icons.Situation />,
    kind: "situation",
    href: "/create-game/situation",
  },
]

type GameGridProps = {
  onSelectGame: (item: GameItem) => void
}

export function GameGrid({ onSelectGame }: GameGridProps) {
  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3">
      {activities.map((activity) => (
        <GameCard key={activity.id} item={activity} onClick={() => onSelectGame(activity)} />
      ))}
    </div>
  )
}
